<div [ngClass]="{'form-group': showLabel}">
  <!-- Added by amisha on 02-01-2026 to show label differently for permit form -->
  @if (!templateForPermitForm) {
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  } @else {
  <wm-common-text
    class="permit-label"
    [data]="{
      text: entity.label,
    }"
  ></wm-common-text>
  }
  <!-- End by amisha on 02-01-2026 -->

  <app-esri-map
    *ngIf="mapsketchDataEntity.mapConfig.mapServiceId"
    #mapComp
    [mapServiceId]="mapsketchDataEntity.mapConfig.mapServiceId"
    [basemapName]="mapsketchDataEntity.mapConfig.basemapName"
    [initialExtent]="mapsketchDataEntity.mapConfig.initialExtent"
    [mapLayerOptions]="mapsketchDataEntity.mapConfig.layers"
    [showToc]="mapsketchDataEntity.mapConfig.showToc"
    [allowZoom]="false"
    useSketchLayer="true"
    (mapLoaded)="onMapLoaded()"
    (sketchLayerReady)="onSketchLayerReady()"
    [startingZoomLevel]="mapsketchDataEntity.mapConfig.initialZoom"
    [popupActions]="mapPopupActions"
  ></app-esri-map>
</div>
